import { useState } from "react";

const useForm = date => {
  const [form, setForm] = useState(date);

  const handleChange = e => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const reset = () => {
    setForm(date);
  };

  return [form, handleChange, reset];
};

export default useForm;
